/* unplugin-vue-components disabled */import script from "./NewAccountTableBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewAccountTableBlock.vue?vue&type=script&setup=true&lang=ts"

import "./NewAccountTableBlock.vue?vue&type=style&index=0&id=6ebf22ca&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ebf22ca"]])

export default __exports__